import React from "react";
import { Modal } from "react-bootstrap";
import { Row, Col } from "antd";

import TextField from "../../Components/Commons/Forms/TextField";
import NumberInputV2 from "../../Components/Commons/Forms/NumberInputV2";
import BtnDelete from "../../Components/Commons/Buttons/BtnDelete";
import BtnSave from "../../Components/Commons/Buttons/BtnSave";
import { validatePrescriptionDetails } from "../../Components/Helpers/Utilities/Validations/Prescription";

const AddPrescriptionModal = ({
  show,
  onClose,
  isClicked,
  newPrescription,
  isError,
  onChange,
  onSubmit,
}) => {
  return (
    <Modal size="lg" show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title className="form-title">Add Prescription</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row gutter={[16, 0]}>
          <Col md={24} lg={12}>
            <TextField
              required
              id="generic"
              name="generic"
              formLabel={`Generic`}
              size={`sm`}
              value={newPrescription.generic}
              onChange={onChange}
              isError={isError.generic}
              errorMessage="Generic is required"
            />
          </Col>
          <Col md={24} lg={12}>
            <TextField
              id="brand"
              name="brand"
              formLabel={`Brand`}
              size={`sm`}
              value={newPrescription.brand}
              onChange={onChange}
            />
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col md={24} lg={12}>
            <TextField
              id="dosage"
              name="dosage"
              formLabel={`Dosage`}
              size={`sm`}
              value={newPrescription.dosage}
              onChange={onChange}
            />
          </Col>
          <Col md={24} lg={12}>
            <TextField
              required
              id="preparation"
              name="preparation"
              formLabel={`Preparation`}
              size={`sm`}
              value={newPrescription.preparation}
              onChange={onChange}
              isError={isError.preparation}
              errorMessage="Preparation is required"
            />
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          {/* <Col md={24} lg={12}>
            <TextField
              id="form"
              name="form"
              formLabel={`Form`}
              size={`sm`}
              value={newPrescription.form}
              onChange={onChange}
            />
          </Col> */}
        </Row>
        <Row gutter={[16, 0]}>
          {/* <Col md={24} lg={12}>
            <TextField
              id="frequency"
              name="frequency"
              formLabel={`Frequency`}
              size={`sm`}
              value={newPrescription.frequency}
              onChange={onChange}
            />
          </Col> */}
          <Col md={24} lg={12}>
            <NumberInputV2
              id="quantity"
              name="quantity"
              formLabel={`Quantity`}
              size={`sm`}
              value={newPrescription.quantity}
              onChange={onChange}
            />
          </Col>
          <Col md={24} lg={12}>
            <TextField
              id="duration"
              name="duration"
              formLabel={`Duration`}
              size={`sm`}
              value={newPrescription.duration}
              onChange={onChange}
            />
          </Col>
        </Row>
        {/* <Row gutter={[16, 0]}>
          <Col md={24}>
            <TextField
              id="timing"
              name="timing"
              formLabel={`Timing`}
              size={`sm`}
              value={newPrescription.timing}
              onChange={onChange}
            />
          </Col>
        </Row> */}
        <Row gutter={[16, 0]}>
          <Col md={24}>
            <TextField
              id="instruction"
              name="instruction"
              formLabel={`Instruction`}
              size={`sm`}
              value={newPrescription.instruction}
              onChange={onChange}
            />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <BtnDelete
          label={"Close"}
          size={"md"}
          onClick={onClose}
          isClicked={isClicked}
        />
        <BtnSave
          label={"Submit"}
          size={"md"}
          onClick={onSubmit}
          isClicked={isClicked}
          disabled={validatePrescriptionDetails(
            newPrescription.prescription_details
          )}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default AddPrescriptionModal;
